define ['./sample.css'], () ->
  ($state, $stateParams, $scope) ->
    if $stateParams['#']
      $('.nav-tabs a[href="#'+$stateParams['#']+'"]').tab('show')

    $scope.current_tab = 'application'

    console.log($scope.current_tab)

    $scope.set_current_tab = (tab) ->
      $scope.current_tab = tab




// WEBPACK FOOTER //
// ./components/home/sample/sample.coffee